export default [
    {
        path: '/my-leads',
        component: require('./../../functional/Index').default,
        meta: {
            breadcrumb: 'Leads'
        },
        children: [
            {
                path: '',
                name: 'Leads',
                component: require('./../../views/Leads/Index').default
            },
            {
                path: 'submit',
                meta: {
                    breadcrumb: 'Submit New Lead'
                },
                component: require('./../../functional/Index').default,
                children: [
                    {
                        path: '',
                        name: 'Submit New Lead',
                        component: require('../../views/Leads/Submit').default
                    }
                ]
            },
            {
                path: 'submit/:intermediaryId',
                meta: {
                    breadcrumb: 'Submit New Lead For Intermediary'
                },
                component: require('./../../functional/Index').default,
                children: [
                    {
                        path: '',
                        name: 'Submit New Lead For Intermediary',
                        component: require('../../views/Leads/Submit').default
                    }
                ]
            },
            {
                path: 'view/:leadId',
                meta: {
                    breadcrumb: 'View Lead'
                },
                component: require('./../../functional/Index').default,
                children: [
                    {
                        path: '',
                        name: 'View Lead',
                        component: require('../../views/Leads/View').default
                    }
                ]
            },
        ]
    }
]
